import { Box, Typography, useMediaQueryContext } from "@drone-js/core";
import type { FunctionComponent } from "react";
import type { GooglePlaceResult } from "../types";

interface Props {
    userInput: string;
    place: GooglePlaceResult;
    onClick: (place: GooglePlaceResult) => void;
}

export const SearchItem: FunctionComponent<Props> = ({ userInput, place, onClick }) => {
    const context = useMediaQueryContext();

    const highlight = (needle: string, haystack: string) => {
        try {
            return haystack.replace(new RegExp(needle, "gi"), (str) => `<strong>${str}</strong>`);
        } catch (_e) {
            return haystack;
        }
    };

    return (
        <Box as="button" width="100%" textAlign="left" p="12" onClick={() => onClick(place)}>
            <Typography variant="body-s" lineClamp={context.m ? 1 : 3}>
                <span
                    dangerouslySetInnerHTML={{
                        __html: highlight(userInput, place.name + " "),
                    }}
                />
                <Box as="span" textColor="base.subtle">
                    {place.formatted_address}
                </Box>
            </Typography>
        </Box>
    );
};
